import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M4.75 17.5V17.223L5.76577 14.1757M5.76577 14.1757L8.07432 7.25H8.62838L10.9369 14.1757L11.9527 17.223V17.5M10.9369 14.1757H5.76577" vectorEffect="non-scaling-stroke" />
		<Path d="M19.25 9.5C19.25 9.5 19.25 13.5533 19.25 14.7886C19.25 16.0239 19.4324 16.75 20.75 16.75M19.25 13.0441C19.25 10.9853 18.0735 10.1618 16.6324 10.1618C15.0405 10.1618 13.75 11.3971 13.75 13.4559C13.75 15.5147 15.0405 16.75 16.6324 16.75C17.8092 16.75 19.25 15.5147 19.25 13.8676" vectorEffect="non-scaling-stroke" />
	</SVG>
);
